
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '../../store/consultorioStore';
import { consultorioService } from '../../services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";
import EditarHistorialModal from "./EditarHistorialModal.vue";

@Component({
	name: "InformacionClinica",
	components: {EditarHistorialModal}
})

export default class InformacionClinicaTab extends Vue {
	@Prop() paciente_id!: number
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();



	valid = true;
	fecha = DateTime.now().toFormat('yyyy-MM-dd');
	tipo_denticion = []
	panel = []
	historial = {
		historia_enfermedad_actual: '',
		antecedentes_personales_patologicos: '',
		paciente_id: this.paciente_id,
		id: null,
	}
	swEditar = false;
	historial_selected = {}
	get historiales(): any {
		return this.consultorioStore.historialMedico;
	}
	mounted() {
		setTimeout(this.getHistorialMedico,1500)
	}
	
	guardar() {
		this.historial.paciente_id = this.paciente_id;
		Alert.confirm(`Se registrar la informacion clinica`, 'Registrar informacion clinica?').then(async result => {
			if (result.isConfirmed) {
				await this.consultorioService.actualizarHistorial(this.historial).then(response => {
					this.getHistorialMedico()
				})

			}
		})

	}
	abrirEditar(historial: any) {
		this.historial_selected = historial;
		this.swEditar = true;
	}
	async getHistorialMedico() {
		let data = {
			paciente_id: this.paciente_id
		}
		this.consultorioStore.loading = true;
		await http.get(`historial-medico`, { params: data }).subscribe({
			next: (response: AxiosResponse) => {
				this.consultorioStore.historialMedico = response.data;
				this.historial.historia_enfermedad_actual = this.consultorioStore.historialMedico[0]?.historia_enfermedad_actual ?? '';
				this.historial.antecedentes_personales_patologicos = this.consultorioStore.historialMedico[0]?.antecedentes_personales_patologicos ?? '';
				this.historial.id = this.consultorioStore.historialMedico[0]?.id ?? null;
				this.consultorioStore.loading = false;

			},
		})
	}
	
	async imprimirHistorial() {
		await http.get(`imprimir-historial/${this.paciente_id}`).subscribe(response => {
			window.open(
				`${process.env.VUE_APP_URL}imprimir-historial/${this.paciente_id}`, "_blank");
			//import.meta.env.VITE_APP_URL +`imprimir-solicitud/${id}`, "_blank");

		})
	}
	async imprimirHistoriaClinica(id: number) {
		await http.get(`imprimir-historia-clinica/${id}`).subscribe(response => {
			window.open(
				`${process.env.VUE_APP_URL}imprimir-historia-clinica/${id}`, "_blank");
		})
	}

}

